import config from '../config';


/**
 * Returns the ful asset CDN url for the given part
 * @param assetUrlPart {string} Absolute asset URL (works with localhost as well)
 * @returns Full asset URL
 */
export const assetUrl = assetUrlPart => {

    const {assetCdnUrl} = config.host;
    // if locally, the asset URL part is absolute
    if (assetCdnUrl === '/') {

        return assetUrlPart;
    }

    return assetCdnUrl + assetUrlPart;
};
